<template>
  <div class="pa-5" v-if="detail">
    <v-card shaped class="elevation-10">
      <v-card-title>
        <div>ข้อมูลการขอกำหนดตำแหน่งทางวิชาการ</div>
        <v-spacer></v-spacer>
        <div>
          {{ `${detail.sit_no} ${detail.ref_prefix_name.initials}${detail.stf_fname} ${detail.stf_lname}` }}
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-btn class="purple darken-1 white--text" tile @click="add_academic">ขอกำหนดตำแหน่ง</v-btn>
      </v-card-text>
      <v-card-text v-if="detail.academic && detail.academic.length === 0">
        <v-subheader>---ไม่พบข้อมูลการขอตำแหน่งทางวิชาการ---</v-subheader>
      </v-card-text>
      <v-card-text v-else>
        <v-card color="elevation-4 mb-5" tile flat v-for="acad in detail.academic" :key="acad.id">
          <v-card-title>
            <span>{{ `${acad.type.name}: สาขาวิชา${acad.program_name} รหัสสาขาวิชา${acad.program_code}` }}</span>
            <v-spacer></v-spacer>
            <v-chip :color="acad.ref_status.color || ''">{{ acad.ref_status.name }}</v-chip>
          </v-card-title>
          <v-card-actions>
            <v-btn v-if="acad.status == 1" tile small color="primary" :to="`/academic/detail/${acad.id}`"><v-icon small>mdi-file-chart</v-icon>รายงาน</v-btn>
            <v-btn v-if="acad.status === 2" tile small color="warning" :href="`https://srru.ac.th/personnel/api/exports/academic_detail/${acad.id}`" target="_blank"><v-icon small>mdi-download</v-icon>ดาวน์โหลดแบบสรุปผล</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="acad.status == 1" tile small color="info" @click="edit_academic(acad)"><v-icon small>mdi-pencil</v-icon>แก้ไข</v-btn>
            <v-btn v-if="acad.status == 1" tile small color="success" @click="approved(acad.id)"><v-icon small>mdi-account-check</v-icon>แต่งตั้ง</v-btn>
            <v-btn v-if="acad.status == 1" tile small color="error" @click="confirm_delete_academic(acad.id)"><v-icon small>mdi-delete</v-icon>ลบ</v-btn>
            <v-btn v-if="acad.status == 2" tile small color="error" @click="clear_status_confirm(acad.id)"><v-icon small>mdi-delete</v-icon>ยกเลิกสถานะ</v-btn>
          </v-card-actions>
        </v-card>
        
      </v-card-text>
    </v-card>

    <academicForm 
      :dialog.sync="academic_dialog" 
      :form="academic_form"
      v-on:submit="submit"
    />
    <academicApproveDialog 
      :dialog.sync="approved_dialog" 
      :form="approved_form"
      v-on:submit="confirm_approved"
    />

    <confirmDialog
      :dialog="academic_confirm_dialog"
      message="คุณต้องการลบคำขอนี้ใช่หรือไม่?"
      v-on:confirm="delete_academic"
    />

    <confirmDialog
      :dialog="clear_status_dialog"
      message="คุณต้องการยกเลิกสถานะการแต่งตั้งใช่หรือไม่?"
      v-on:confirm="clear_status"
    />
    
  </div>
</template>

<script>
import academicForm from './AcademicFormDialog';
import academicApproveDialog from './AcademicApproveDialog';
import confirmDialog from '@/components/ConfirmDialog';

export default {
  components: {
    academicForm: academicForm,
    academicApproveDialog: academicApproveDialog,
    confirmDialog: confirmDialog
  },
  data: () => ({
    academic_dialog: false,
    academic_submit_type: '',
    academic_form: {
      mis_id: '',
      academic_type_id: '',
      program_name: '',
      program_code: ''
    },
    academic_confirm_dialog: false,
    academic_delete_selected: '',
    // Approved //
    approved_dialog: false,
    approved_form: {
      approved_date: '',
      present_date: '',
      present_time: ''
    },
    clear_status_dialog: false,
    clear_status_selected: ''
    // approved_confirm_dialog: false,
    // approved_delete_selected: '',
  }),
  computed: {
    detail() { return this.$store.state.academic.selected }
  },
  created() {
    if(!this.detail) {
      this.$router.push({ name: 'AcademicIndex' });
    }
  },
  methods: {
    get_academic() {
      this.$store.dispatch('academic/getAcademic', this.detail.citizen_id.replaceAll('-', ''));
    },
    add_academic() {
      this.academic_submit_type = 'NEW';
      this.academic_dialog = true;
      this.clear_academic_form();
    },
    edit_academic(academic) {
      this.academic_submit_type = 'EDIT';
      this.academic_dialog = true;
      this.academic_form = {
        id: academic.id,
        mis_id: this.detail.id,
        academic_type_id: academic.academic_type_id,
        program_name: academic.program_name,
        program_code: academic.program_code
      }
    },
    delete_academic(condition) {
      if(condition) {
        this.$store.dispatch('academic/deleteAcademic', this.academic_delete_selected).then(res => {
          this.academic_confirm_dialog = false;
          this.$store.dispatch('academic/getAcademic', this.detail.citizen_id.replaceAll('-', ''));
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'success',
            message: res.message
          });
        }).catch(() => {
          this.academic_dialog = false;
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'error',
            message: 'เกิดข้อผิดพลาดบางอย่าง'
          });
        })
      } else {
        this.academic_confirm_dialog = false;
      }
    },
    confirm_delete_academic(id) {
      this.academic_confirm_dialog = true;
      this.academic_delete_selected = id;
    },
    submit(form_data) {
      this.$store.dispatch(`academic/${this.academic_submit_type === 'NEW' ? 'storeAcademic' : 'updateAcademic' }`, form_data).then(res => {
        this.academic_dialog = false;
        this.$store.dispatch('academic/getAcademic', this.detail.citizen_id.replaceAll('-', ''));
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: res.message
        });
      }).catch(() => {
        this.academic_dialog = false;
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'error',
          message: 'เกิดข้อผิดพลาดบางอย่าง'
        });
      })
    },
    clear_academic_form() {
      this.academic_form = {
        mis_id: this.detail.id,
        academic_type_id: '',
        program_name: '',
        program_code: ''
      }
    },
    approved(id) {
      this.approved_form = {
        id: id,
        approved_date: new Date().toISOString().substr(0, 10),
        present_date: new Date().toISOString().substr(0, 10),
        present_time: ''
      }
      this.approved_dialog = true;
    },
    confirm_approved() {
      this.$store.dispatch(`academic/approve`, this.approved_form).then(res => {
        this.get_academic();
        this.approved_dialog = false;
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: res.message
        });
      }).catch(() => {
        this.approved_dialog = false;
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'error',
          message: 'เกิดข้อผิดพลาดบางอย่าง'
        });
      })
    },
    download(id) {
      this.$store.dispatch('academic/download', id);
    },
    clear_status_confirm(id) {
      this.clear_status_selected = id;
      this.clear_status_dialog = true;
    },
    clear_status(condition) {
      if(condition) {
        this.$store.dispatch('academic/clear_status', this.clear_status_selected).then(res => {
          this.clear_status_dialog = false;
          this.get_academic();
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'success',
            message: res.message
          });
        }).catch(() => {
          this.approved_dialog = false;
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'error',
            message: 'เกิดข้อผิดพลาดบางอย่าง'
          });
        });
      } else {
        this.clear_status_dialog = false;
      }
    }
  },
  destroyed() {
    // this.$store.commit('academic/SET_SELECTED', null);
  }
}
</script>

<style lang="scss">
.v-expansion-panel-content__wrap {
  padding: 0;
}
</style>